// extracted by mini-css-extract-plugin
module.exports = {"cardColumn":"CrudContent_cardColumn__ZsBDy","card":"CrudContent_card__2jhB0","dataDisplay":"CrudContent_dataDisplay__1bQRi","borderless":"CrudContent_borderless__1Njdx"};